import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationDialogService } from 'src/app/confirmation-dialog/confirmation-dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpService } from 'src/app/services/http.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { URLUtils } from 'src/app/urlUtils';
import { ensureActiveSubscription } from 'src/app/shared/subscription-dialog';
import { environment } from 'src/environments/environment';
import { debounceTime, distinctUntilChanged, filter, map, Observable, of, startWith, switchMap } from 'rxjs';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Motorbike } from 'lucide-angular';
import { tr } from 'date-fns/locale';
import { ConfirmDialogComponent } from 'src/app/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SuccessDialogComponent } from 'src/app/success-dialog/success-dialog.component';

interface Entity {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    country: string;
    mobile: string;
}

@Component({
    selector: 'individual',
    templateUrl: 'individual.component.html',
    styleUrls: ['individual.component.scss'],
    standalone: false
})

export class IndividualComponent {


    constructor(private fb: FormBuilder, private dialog: MatDialog,
        private httpservice: HttpService,
        private confirmationDialogService: ConfirmationDialogService,
        private router: Router, private toast: ToastrService,
        private cd: ChangeDetectorRef) {
        this.searchForm = this.fb.group({ email: ['', [Validators.required, Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)]] });
    }

    submitted: boolean = false;
    confirmEmail: any;

    @ViewChild(MatAutocompleteTrigger) autoTrigger!: MatAutocompleteTrigger;

    searchForm: any;
    sfSubmitted: boolean = false;
    showForm: boolean = false;
    formMode: string = 'request'; //invite
    searchTerm: string = "";
    consumerId: string = "";
    msg: string = "";
    groupList: any[] = [];
    selectedGroups: any[] = [];
    groupFilter: string = "";
    reqError: any = { show: false, msg: "" }
    countryList: any;
    selname: string = "";
    showConfirm: boolean = false;
    showSuccess: boolean = false;
    createdId: string = "";
    searchText: any;
    isDisabled = true;
    createRelationform: any = {};
    countries: any;
    product = environment.product;
    closeMode: boolean = false;

    selectedEntity = new FormControl<any>("");
    //selectedEntityObject = { entityId: "" };
    selectedEntityObject: Entity | any = null;

    filteredEntities: any;
    entityList: any[] = [];
    emptySearchError: boolean = false;
    filteredEntityList: any[] = [];
    latestEntities: any[] = [];




    ngOnInit() {
        this.createRelationform = this.fb.group({
            firstName: [{ value: '', disabled: this.isDisabled }, Validators.required],
            country: [{ value: '', disabled: this.isDisabled }, Validators.required],
           //confirmEmail: [{ value: '', disabled: this.isDisabled }, Validators.required, Validators.email],
            // confirmEmail: [
            //     { value: '', disabled: this.isDisabled },
            //     [Validators.required, Validators.email] 
            // ],
            email: [
                { value: '', disabled: this.isDisabled },
                [Validators.required, Validators.email]
            ],
            confirmEmail: [
                { value: '', disabled: this.isDisabled },
                [Validators.required, Validators.email]
            ],

            lastName: [{ value: '', disabled: this.isDisabled }, Validators.required],
            mobile: [{ value: '', disabled: this.isDisabled }], 
            grpsearch: []
        }, { validators: this.emailMatchValidator });

        this.loadGroups()
        this.loadCountries()

        this.httpservice.sendGetRequest(URLUtils.country).subscribe(
            (res: any) => {
                this.countries = res.data.countries;
                this.countries.shift();
            }
        )

        this.selectedEntity.valueChanges.subscribe(value => {
            if (typeof value === 'string') {
                this.selectedEntityObject = null;
            }
        });

        // this.filteredEntities = this.selectedEntity.valueChanges.pipe(
        //     debounceTime(300),

        //     filter(value =>
        //         typeof value === 'string' && value.trim().length >= 2
        //     ),

        //     switchMap(value =>
        //         this.httpservice.sendPostRequest(URLUtils.searchConsumer, {
        //             search: value.trim()
        //         }).pipe(
        //             map((resp: any) => resp?.data || [])
        //         )
        //     )
        // );
        // this.filteredEntities = this.selectedEntity.valueChanges.pipe(
        //     debounceTime(300),
        //     filter(value =>
        //         typeof value === 'string' && value.trim().length >= 2
        //     ),

        //     switchMap(value =>
        //         this.httpservice.sendPostRequest(URLUtils.searchConsumer, {
        //             search: value.trim()
        //         }).pipe(
        //             map((resp: any) => resp?.data || [])
        //         )
        //     )
        // );

        this.filteredEntities = this.selectedEntity.valueChanges.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            switchMap(value => {
                if (typeof value !== 'string' || value.trim().length < 2) {
                    return of([]); // 👈 return empty list when input is short/empty
                }

                return this.httpservice.sendPostRequest(URLUtils.searchConsumer, {
                    search: value.trim()
                }).pipe(
                    map((resp: any) => resp?.data || [])
                );
            })
        );

    }

    emailMatchValidator(form: FormGroup) {
        const email = form.get('email')?.value;
        const confirmEmail = form.get('confirmEmail')?.value;

        if (!email || !confirmEmail) return null;

        if (email !== confirmEmail) {
            form.get('confirmEmail')?.setErrors({ mismatch: true });
            return { mismatch: true };
        } else {
            // Clear mismatch error if they match
            const errors = form.get('confirmEmail')?.errors;
            if (errors) {
                delete errors['mismatch'];
                if (Object.keys(errors).length === 0) {
                    form.get('confirmEmail')?.setErrors(null);
                }
            }
            return null;
        }
    }

    get email() { return this.searchForm.get('email'); }
    get f() { return this.createRelationform.controls; }

    onOptSel(event: any) {
        this.selectedEntityObject = event.option.value;
        // console.log('Selected entity:', this.selectedEntityObject);
        // console.log('Selected-Entity:', this.selectedEntity);                
        // console.log('reqError', this.reqError)
        // console.log('formMode', this.formMode)
        // console.log('msg', this.msg)
        // console.log('closeMode', this.closeMode)

        // Show form
        this.showForm = true;
        this.formMode = 'request';

        // Populate form
        this.createRelationform.patchValue({
            firstName: this.selectedEntityObject?.first_name,
            lastName: this.selectedEntityObject?.last_name,
            email: this.selectedEntityObject?.email,
            mobile: this.selectedEntityObject?.mobile,
            country: this.selectedEntityObject?.country
        });

        // Disable fields
        Object.values(this.createRelationform.controls).forEach((ctrl: any) => ctrl.disable());

        this.consumerId = this.selectedEntityObject?.id;
        // UI messages
        this.selname = `${this.selectedEntityObject?.first_name} ${this.selectedEntityObject?.last_name}`;
        this.msg = `Individual ${this.selname} Found.`;

        this.emptySearchError = false;
        //clear field
        this.selectedEntity.setValue('', { emitEvent: true });
        this.autoTrigger.closePanel();
        this.reqError.show = false;
        this.reqError.msg = '';
    }

    displayEntity(entity: any): string {
        return entity ? `${entity.first_name} ${entity.last_name}` : '';
    }

    maskEmail(email: string): string {
        if (!email) return '';

        const [name, domain] = email.split('@');
        if (!domain) return email;

        const maskedName =
            name.length <= 2
                ? name[0] + '*'
                : name.substring(0, 2) + '*'.repeat(name.length - 2);

        return `${maskedName}@${domain}`;
    }
        
    maskMobile(mobile: string): string {
        if (!mobile) return '';

        const visibleDigits = 3;
        return '*'.repeat(mobile.length - visibleDigits) + mobile.slice(-visibleDigits);
    }


    searchConsumer(val: any) {
        if (!ensureActiveSubscription(this.confirmationDialogService)) { return; }
        this.httpservice.sendPostRequest(URLUtils.searchConsumer,
            { "search": val }).subscribe((resp: any) => { })
    }

    clearIfEmpty() {
        if (!this.selectedEntity.value) {
            this.selectedEntityObject = null;
            this.showForm = false;
            this.msg = '';
            this.selname = '';
        }
    }

    onInputChange(event: any) {
        this.restrictSpaces(event);
        this.clearIfEmpty();
        this.createRelationform.reset();

        // reopen panel when typing
        // if (this.selectedEntity.value?.length >= 2) {
        //     this.autoTrigger.openPanel();
        // }
        // else {
        //     this.autoTrigger.closePanel();
        // }
        // console.log('Input changed:', this.selectedEntity.value);
        // console.log('Selected entity object:', this.selectedEntityObject);
    }

    onSubmit() {
        this.submitted = true;
    }

    onGrpSearch(evt: any) {
        this.groupFilter = evt.target.value
    }

    // search() {
    //     this.sfSubmitted = true;
    //     this.emptySearchError = false;
    //     this.reqError.show = false;

    //     // No entity selected
    //     if (!this.selectedEntityObject || !this.selectedEntityObject.id) {
    //         this.emptySearchError = true;
    //         return;
    //     }

    //     // Entity FOUND
    //     this.showForm = true;
    //     this.formMode = 'request';

    //     this.msg = `${this.selectedEntityObject?.first_name} ${this.selectedEntityObject.last_name} found.`;

    //     // populate form
    //     this.createRelationform.patchValue({
    //         firstName: this.selectedEntityObject.first_name,
    //         lastName: this.selectedEntityObject.last_name,
    //         confirmEmail: this.selectedEntityObject.email,
    //         country: '' // optional
    //     });

    //     Object.keys(this.createRelationform.controls).forEach(key => {
    //         this.createRelationform.controls[key].disable();
    //     });

    //     this.selname = `${this.selectedEntityObject?.first_name} ${this.selectedEntityObject.last_name}`;

    // if (!ensureActiveSubscription(this.confirmationDialogService)) { return; }

    // this.sfSubmitted = true;
    //     this.closeMode = false;
    //     this.emptySearchError = false;
    //     this.reqError.show = false;
    //     if (this.searchForm.invalid) { return; }
    //     let semail = this.searchForm.value['email']
    //     this.httpservice.sendPostRequest(URLUtils.searchConsumer,
    //     {"email": semail }).subscribe((resp: any) => {
    //         if(!resp.error){
    //             this.consumerId = resp['consumerId']
    //             this.msg = resp.msg
    //             let fields = ["firstName", "lastName", "country"]
    //             fields.forEach((item: string, index: number) => {
    //                 let ctl = this.createRelationform.controls[item]
    //                 ctl.setValue(resp[item])
    //                 ctl.disable()
    //             })
    //             this.selname = `${resp['firstName']} ${resp['lastName']}`
    //             let ce = this.createRelationform.controls['confirmEmail']
    //             ce.setValue(semail)
    //             ce.disable()
    //             this.showForm = true
    //             this.formMode = 'request'
    //             this.loadGroups()
    //             this.selectedGroups = []
    //         } else {
    //             this.showForm = true
    //                this.emptySearchError = true;
    //             this.createRelationform.reset();
    //             this.formMode = 'invite'
    //             this.msg = `${semail} - not found. Please fill in the details below to send the relationship invite.`
    //             this.loadGroups()
    //             this.selectedGroups = []
    //             let fields = ["firstName", "lastName", "country", "confirmEmail"]
    //             fields.forEach((item: string, index: number) => {
    //                 this.createRelationform.controls[item].enable()
    //             })

    //         }
    //     })
    // }
    // searchxx() {
    //     // console.log('this.selectedEntity',this.selectedEntity.value)
    //     // console.log('this.selectedEntityObject',this.selectedEntityObject)
    //     if (this.selectedEntity.value === '') {
    //         return
    //     }

    //     this.sfSubmitted = true;
    //     this.emptySearchError = false;
    //     this.reqError.show = false;

    //     // User typed but did not select
    //     if (!this.selectedEntityObject) {
    //         this.showForm = true;
    //         this.formMode = 'invite';
    //         this.msg = `${this.selectedEntity.value} - not found. Please fill in the details below to send the relationship invite.`;

    //         // Enable form for manual entry
    //         Object.values(this.createRelationform.controls).forEach((ctrl: any) => ctrl.enable());
    //         this.createRelationform.reset();

    //         return;
    //     }
    // }

    search() {
        const searchValue = this.selectedEntity.value?.trim();

        if (!searchValue) {
            //this.emptySearchError = true;
            this.toast.warning('Please enter Individual name to search')
            this.createRelationform.reset();
            this.showForm = false;
            return;
        }
        this.emptySearchError = false;

        // Find entity from latest API response
        const matchedEntity = this.latestEntities.find(entity =>
            `${entity.first_name} ${entity.last_name}`.toLowerCase() === searchValue.toLowerCase()
        );

        if (matchedEntity) {
            // behave exactly like option selection
            this.onOptSel({ option: { value: matchedEntity } });
            return;
        }

        // NOT FOUND → invite flow
        this.selectedEntityObject = null;
        this.showForm = true;
        this.formMode = 'invite';
        this.msg = `${searchValue} - not found. Please fill in the details below to send the relationship invite.`;

        Object.values(this.createRelationform.controls).forEach((ctrl: any) => ctrl.enable());
        this.createRelationform.reset();

        // Country is not known for an invite - default to India and don't allow it to be changed
        this.createRelationform.controls['country'].setValue('India');
        this.createRelationform.controls['country'].disable();
    }


    resetEmailConf() {
        this.createRelationform.controls['confirmEmail'].setErrors(null)
    }

    getConfirmation() {
        // console.log('createRelationform',this.createRelationform.value)
        // console.log('searchForm',this.searchForm.value)
        if (this.createRelationform.invalid) { 
            this.submitted = true;
            return; 
        }

        //let vals = this.createRelationform.value
        let vals = this.createRelationform.getRawValue();
        //console.log('val',vals)
        
        //if (vals.grpsearch !== null) { 
        if ((vals.firstName === '' || vals.firstName === null) ||
            (vals.lastName === '' || vals.lastName === null) ||
            (vals.email === '' || vals.email === null) ||
            (vals.country === '' || vals.country === null)) {
            this.submitted = true;
            this.toast.error('Please verify all your information before sending the invite.');
            return;
        }
        //}

        if (this.formMode == 'invite') {
            this.selname = `${vals['firstName']} ${vals['lastName']}`
        }
        
        // let semail = this.searchForm.value['email']
        // console.log('semail',semail)
        // console.log('cform',this.createRelationform)

        // let form = this.createRelationform
        // if (form.controls['confirmEmail'].value != semail) {
        //     form.controls['confirmEmail'].setErrors({ 'mismatch': true })
        // }
        //  this.showConfirm = true

        if (this.createRelationform.invalid) { 
            this.submitted = true;
            return; 
        }
        else{
            //this.showConfirm = true
            this.showconfirmDialog();
        }
    }

    showconfirmDialog() {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            data: { title: 'Confirmation', message: `Are you sure you want to send relationship request to ${this.selname}?` }
        });
        dialogRef.afterClosed().subscribe((result: any) => {
            //console.log('Dialog result:', result);
            if (result) {
                this.sendReq();
            }
        });
    }
    onReset() {
        // Reset flags
        this.submitted = false;
        this.sfSubmitted = false;
        this.emptySearchError = false;
        this.reqError.show = false;
        this.closeMode = true;

        // Clear messages
        this.msg = '';
        this.selname = '';

        // Clear autocomplete input
        this.selectedEntity.setValue('', { emitEvent: true });
        this.selectedEntityObject = null;

        // Reset & disable form
        this.createRelationform.reset();
        Object.values(this.createRelationform.controls).forEach((ctrl: any) => ctrl.disable());

        // Hide form
        this.showForm = false;

        // Clear groups (optional but recommended)
        this.selectedGroups = [];
        this.loadGroups();
    }


    // onReset() {
    //     this.submitted = false;
    //     this.createRelationform.reset();
    //     this.showForm = false;
    //     this.reqError.show = false;
    //     this.msg = '';
    //     this.groupList = [];
    //     this.sfSubmitted = false;
    //     this.closeMode = true; //remove the formMode msg & selectedGrps
    //     this.searchForm.controls['email'].setValue("")
    //     this.selectedEntityObject = null; //clear val
    // }
    loadGroups() {
        this.httpservice.sendGetRequest(URLUtils.getGroups).subscribe((res: any) => {
            //this.groupList = res?.data;
            this.groupList = res?.data.filter((group: any) => group.name !== 'AAM' && group.name !== 'SuperUser');
        })
    }
    loadCountries() {
        this.httpservice.sendGetRequest(URLUtils.getCountries).subscribe((res: any) => {
            this.countryList = res.data['countries']
        })



    }
    selgrp(grp: any) {
        this.selectedGroups.push(grp)
        this.groupList.splice(this.groupList.indexOf(grp), 1);
    }
    restore(grp: any) {
        this.selectedGroups.splice(this.selectedGroups.indexOf(grp), 1);
        this.groupList.push(grp)
    }

    successResp(option: string) {
        if (option == 'view') {
            //this.router.navigate([`/relationship/view/individuals/${this.createdId}`])
            // this.router.navigate([`/relationship/view/individuals`])
            this.router.navigate(
                ['/relationship/view/individuals'],
                { queryParams: { highlightId: this.createdId } }
            );
        }
        if (option == 'add') {
            this.showSuccess = false
            this.onReset()
            this.msg = ""
            this.selectedGroups = []
            this.loadGroups()
            this.router.navigate(["/relationship/add/individual"])
        }
    }

    sendReq() {
        //this.createRelationform.controls['confirmEmail'].setErrors(null)
        this.submitted = true
        // let form = this.createRelationform;
        // let semail = this.searchForm.value['email']
        // if (form.controls['confirmEmail'].value != semail) {
        //     form.controls['confirmEmail'].setErrors({ 'mismatch': true })
        // }
        //if (this.createRelationform.invalid) { return; }
        if (this.formMode == 'request') {
            let body = {
                "consumerId": this.consumerId,
                "description": "Description",
                "groupAcls": this.selectedGroups.map((x) => { return x.id })
            }
            this.httpservice.sendPostRequest(URLUtils.relationshipConsumerRequest, body).subscribe(
                (resp: any) => {
                    if (resp.error) {
                        this.reqError.show = true
                        this.reqError.msg = resp.msg
                        this.submitted = false
                        this.showConfirm = false
                        this.closeMode = false;
                        this.toast.error(resp.msg);
                    } else {
                        this.showConfirm = false
                        //this.showSuccess = true
                         this.toast.success(resp.msg);
                         this.successResp('view');
                        this.createdId = resp['createdId']
                    }
                },
                (error: HttpErrorResponse) => {
                    if (error.status === 401 || error.status === 403) {
                        const errorMessage = error.error.msg || 'Unauthorized';
                        this.toast.error(errorMessage);
                        //console.log(error);
                    }
                }
            )
        }
        if (this.formMode == 'invite') {
            //var vals = this.createRelationform.value
            let vals = this.createRelationform.getRawValue();

            let body = {
                "first_name": vals['firstName'],
                "last_name": vals['lastName'],
                "email": vals['confirmEmail'],
                "mobile": vals['mobile'],
                "country": vals['country'],
                //"group_acls": this.selectedGroups.map((x) => { return x.id })
            }
            //console.log('body',body)
            this.httpservice.sendPostRequest(URLUtils.relationshipInviteConsumer, body).subscribe(
                (resp: any) => {
                    if (resp.error) {
                        
                        this.reqError.msg = resp.msg
                        if (resp.msg.email) {
                            this.reqError.show = false
                            this.createRelationform.controls['email'].setErrors({
                                serverError: resp.msg.email
                            });
                            console.log('Servererr:',this.createRelationform.controls['email'].setErrors({
                                serverError: resp.msg.email
                            }))
                            return
                        }
                        this.reqError.show = true
                        this.toast.error(resp.msg);
                    } else {
                        this.showConfirm = false
                        this.showSuccess = true
                        this.createdId = resp['createdId']
                    }
                },
                (error: HttpErrorResponse) => {
                    if (error.status === 401 || error.status === 403) {
                        const errorMessage = error.error.msg || 'Unauthorized';
                        this.toast.error(errorMessage);
                        //console.log(error);
                    }
                }
            )
        }
    }
    restricttextSpace(event: any) {
        let inputValue: string = event.target.value;
        inputValue = inputValue.replace(/^\s+/, '');
        inputValue = inputValue.replace(/\s{2,}/g, ' ');
        event.target.value = inputValue;
        return;
    }
    shouldDisableSubmit(): boolean {
        return this.createRelationform.invalid ||
            this.selectedGroups.length === 0 ||
            this.searchForm.invalid
    }

    restrictSpaces(event: any) {
        let inputValue: string = event.target.value;
        if (inputValue.length > 0 && inputValue.charAt(0) === ' ') {
            inputValue = inputValue.substring(1);
            event.target.value = inputValue;
            return;
        }
    }

    back() {
        this.router.navigate([`/relationship/view/individuals`])
    }
}